/**
 * API base URL for the ecommerce storefront (no tenant imports — avoids cycles).
 */

const isLocalHostname = (hostname) =>
  hostname === 'localhost'
  || hostname === '127.0.0.1'
  || hostname.endsWith('.localhost');

export function getApiUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  if (typeof window !== 'undefined' && isLocalHostname(window.location.hostname)) {
    return '/api/v1';
  }

  return 'https://business-manager-production.up.railway.app/api/v1';
}

export const API_URL = getApiUrl();
